export const getLocaleProperty = (
	object: any,
	property: string,
	language: string
) => {
	const value = object[`${property}_${language}` as keyof typeof object];
	return value ? value : object[`${property}_ua` as keyof typeof object];
};
